// import config from '@/config/index' // 路径配置
import { loading } from '@/common/loading'
import {
	getCollectionTask, 
	getIssueRangeList,
	checkLogin, 
} from '@/api/baseMsgtb'
// import nativeJSBridge from '@/utils/nativeJSBridge'

export default {
	name: 'jiagecaiji',
	data() {
		return {
			type: this.$route.query.type,
			// =========start======by wangry
			title: '首页',
			tableList: [],
            active:0,
            // active2: !Number(this.$route.query.active2)? 0: Number(this.$route.query.active2),
            active2: this.$route.query.active==1 ? 1:0,
			startTime: '',
			endTime: '',
			loading1: false, //tabcard加载
			finished: false,
			todayCardList: [], //当日卡片列表
			allCardList: [], //全部卡片列表
			isBarNav: false,
			btnFlag: false,
			isBlue: 'blue2', //蓝色
			isGreen: 'green', //绿色
			isGrey: 'grey', //灰色
			isLoading: false,
			//===========end==========
			loginStatus: true,
			option1: [],
			option2: [],
		}
	},
	created() {
		this.init()
	},
	mounted() {
		window.addEventListener('scroll', this.scrollToTop)
	},
	destroyed() {
		window.removeEventListener('scroll', this.scrollToTop)
	},
	methods: {
		pushMy() {
			this.$router.push({ path: '/perInfoManage/perInfoManage'});
		},
		init() {
			loading(true)
			this.checkLogin();
            if (this.loginStatus) {
                this.getCollectionTask();
                this.getIssueRangeList();
			}
			// nativeJSBridge.hideNativeLoading();
		},
		toList(item) {
			//跳转  价格采集页面
			this.$router.push({
				path: '/caijixiangqingTB',
				query: {
					code: item.tempCode,
					taskCode: item.taskCode,
					exeno: item.exeno,
					StationCode: item.stationCode,
					RegionCode: item.RegionCode,
					taskId: item.taskID,
					shopId: item.shopId,
					shispflag: item.shispflag,
					shengspflag: item.shengspflag,
                    dlrflag:item.dlrflag,//待录入
                    dsbflag:item.dsbflag,//待上报
                    ythflag:item.ythflag,//已退回
                    active2: this.active2,
                    levelNum:item.levelNum,
                    priceDate:item.priceDate,
                    // xianspflag:item.xianspflag,
                    lateReportTime:item.lateReportTime,
				},
			})
		},
		navSwitch() {
			this.isBarNav = !this.isBarNav
		},
		//当日任务
		getCollectionTask() {
			getCollectionTask({
				// id:this.tableList[this.active].id,   //日报 周报 旬报 月报切换
				// id: -1,
                active:0,
			}).then((res) => {
				this.todayCardList = res.data
				loading(false)
			})
		},
		//全部任务
		getAllCollectionTask() {
			getCollectionTask({
				// id:this.tableList[this.active].id, //日报 周报 旬报 月报切换
				// id: -1,
                active:1,
				startTime: this.startTime, //开始时间
				endTime: this.endTime, //结束时间
			}).then((res) => {
				this.allCardList = res.data
				loading(false)
			})
		},
		//置顶图标
		backTop() {
			const that = this
			const timer = setInterval(() => {
				const ispeed = Math.floor(-that.scrollTop / 5)
				document.documentElement.scrollTop = document.body.scrollTop =
					that.scrollTop + ispeed
				if (that.scrollTop === 0) {
					clearInterval(timer)
				}
			}, 16)
		},
		// 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
		scrollToTop() {
			const that = this
			const scrollTop =
				window.pageYOffset ||
				document.documentElement.scrollTop ||
				document.body.scrollTop
			that.scrollTop = scrollTop
			that.btnFlag = that.scrollTop > 130
			// that.isBarNav = that.scrollTop > 10;
		},
		onRefresh() {
			setTimeout(() => {
				this.isLoading = false
				this.init()
			}, 300)
		},
		tabsClick() {
			//周报等tabs
			// this.initTime()
			this.active2 = 0
			this.tabsInnerClick() //初始化任务tabs
			this.getAllCollectionTask()
		},
		tabsInnerClick() {
			//任务tabs
			// loading(true)
			if (this.active2 == 0) {
				this.getCollectionTask() //加载当日任务接口
			} else {
				this.getAllCollectionTask()
			}
		},
		onClickLeft() {
			this.$router.push({
				path: '/',
			})
		},
		search() {
			this.getAllCollectionTask()
		},
		onLoad() {
			//tabcard加载函数
			// 异步更新数据
			// setTimeout 仅做示例，真实场景中一般为 ajax 请求
			setTimeout(() => {
				// 加载状态结束
				this.loading1 = false
				this.finished = true
				// // 数据全部加载完成
			}, 1000)
		},
		//登陆状态监测 houcc 2021.07.24
		checkLogin() {
            checkLogin({}).then(res => {
                if (!res.success) {
                    // nativeJSBridge.logout();
					this.$router.push({ path: '/loginOld'});
                }
                this.loginStatus = res.success;
            })
		},
		// 获取期号范围函数===wangry 2022-01-11
		getIssueRangeList() {
			getIssueRangeList({}).then(res =>{
				// let arr = [];
				// if(res) {
				// 	res.forEach(element => {
				// 		let obj = {};
				// 		obj.value=element.exeNoCode;
				// 		obj.text=element.exeNoName;
				// 		arr.push(obj);
				// 	});
				res.data.forEach(i=> {
                    if(i.codeName == '全部') {
                        i.codeValue = ''
                    }
                    i.value = i.codeValue
                    i.text = i.codeName
                })
					this.option1 = res.data;
					this.option2 = res.data;
                this.endTime = this.$route.query.endTime ? this.$route.query.endTime : res[1].value
                this.startTime = this.$route.query.startTime ? this.$route.query.startTime : res[1].value

                    this.getAllCollectionTask();
				// }
			})
		}
	},
	watch: {
		$route() {
			this.type = this.$route.query.type
		},
	},
}
